import { EPermission } from '@/plugins/role-permissions/types/index';

export enum EPermissionSubject {
  HOME = 'home',
  PROMO = 'promo',
  STATS = 'stats',
  USERS = 'users',
  INVITE = 'invite',
  BALANCE = 'balance',
  SETTINGS = 'settings',
  WITHDRAW = 'withdraw',
  PAYMENTS = 'payments',
  DASHBOARD = 'dashboard',
  TOKEN_MANAGE = 'token_manage',
  TOKEN_PROMOTION = 'token_promotion',
  DAILY_CHECK_IN = 'daily_checkin',
  MISSIONS_AND_REWARDS = 'missions_&_rewards',
  HAPPY_HOURS = 'happy_hours',
  ONBOARDING = 'onboarding',
  P2E = 'p2e',
  H2E = 'h2e',
  COPY_STAKE = 'copy_stake',
  API = 'api'
}

export enum EPermissionSuperAdmin {
  SUPER_ADMIN_ROLES = 'super_admin_roles',
  SUPER_ADMIN_CASTODY = 'super_admin_castody',
  SUPER_ADMIN_DEPLOY = 'super_admin_deploy',
  SUPER_ADMIN_MINT = 'super_admin_mint',
  SUPER_ADMIN_LIVEKIT_SETTINGS = 'super_admin_livekit_settings',
  SUPER_ADMIN_FEATURE_FLAG_CS_SETTINGS = 'super_admin_feature_flag_cs_settings'
}

export type EPermissionSubjectSuperAdmin =
  | EPermissionSubject
  | EPermissionSuperAdmin;

export enum EPermissionSubjectHome {
  TOKEN = 'token',
  COLORS = 'colors',
  INTEGRATION = 'integration'
}

export enum EPermissionSubjectSettings {
  SOCIAL = 'social',
  FEATURE = 'feature',
  FEATURE_COPYSTAKE = 'feature_copystake',
  LANGUAGE = 'language',
  CURRENCY = 'currency',
  EVENT = 'event',
  COMPANY_INFO = 'company_info',
  ROlES = 'roles',
  RESET_GGR = 'reset_ggr'
}

export enum EPermissionSubjectCopyStake {
  STREAMERS = 'streamers',
  GAMIFICATION_CENTER = 'gamification_center'
}

export enum EPermissionSubjectTokenManage {
  WALLETS = 'wallets',
  TRANSACTIONS = 'transactions',
  LIQUIDITY_POOL = 'liquidity_pool'
}

export enum EPermissionSubjectApi {
  GET_TOKEN_PRICE_DATA = 'get_token_price_data',
  GET_CLIENTS_INFO = 'get_clients_info'
}

export type TPermissionSubjectSimple = EPermission[] | boolean;

export type TPermissionSubject<T extends string = string> =
  | Partial<Record<T, TPermissionSubjectSimple>>
  | TPermissionSubjectSimple;

export type IPermissionConfigDefault = Partial<
  Record<EPermissionSubject, TPermissionSubject>
>;

export interface IPermissionConfig extends IPermissionConfigDefault {
  [EPermissionSubject.HOME]: TPermissionSubject<EPermissionSubjectHome>;
  [EPermissionSubject.SETTINGS]: TPermissionSubject<EPermissionSubjectSettings>;
  [EPermissionSubject.COPY_STAKE]: TPermissionSubject<EPermissionSubjectCopyStake>;
  [EPermissionSubject.TOKEN_MANAGE]: TPermissionSubject<EPermissionSubjectTokenManage>;
  [EPermissionSubject.API]: TPermissionSubject<EPermissionSubjectApi>;
}

export type TPermissionRuleMain = Lowercase<keyof typeof EPermissionSubject>;
export type TPermissionSuperAdmin = Lowercase<
  keyof typeof EPermissionSuperAdmin
>;
export type TSettingsRule = Lowercase<keyof typeof EPermissionSubjectSettings>;
export type THomeRule = Lowercase<keyof typeof EPermissionSubjectHome>;
export type TCopyStakeRule = Lowercase<
  keyof typeof EPermissionSubjectCopyStake
>;
export type TTokenManageRule = Lowercase<
  keyof typeof EPermissionSubjectTokenManage
>;
export type TApiRule = Lowercase<keyof typeof EPermissionSubjectApi>;

export type TPermissionRuleKey =
  | `settings ${TSettingsRule}`
  | `home ${THomeRule}`
  | `copy_stake ${TCopyStakeRule}`
  | `token_manage ${TTokenManageRule}`
  | `api ${TApiRule}`
  | TPermissionSuperAdmin
  | TPermissionRuleMain;
